<div ngbDropdown class="d-inline-block" placement="bottom-right">
  <button ngbDropdownToggle class="button" [inlineSVG]="'/assets/svg/print.svg'"></button>
  <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownBasic1">
    <button class="dropdown-item">Print All</button>
    <button class="dropdown-item">Print Current View</button>
    <button class="dropdown-item" *ngIf="selectedCount > 0">Print Selected</button>
  </div>
</div>
